export default __webpack_public_path__ + "static/media/help_2_chat.429e0eb7.gif";